/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ManagementRequestType {
    AUTH_CERT_REGISTRATION_REQUEST = 'AUTH_CERT_REGISTRATION_REQUEST',
    CLIENT_REGISTRATION_REQUEST = 'CLIENT_REGISTRATION_REQUEST',
    OWNER_CHANGE_REQUEST = 'OWNER_CHANGE_REQUEST',
    CLIENT_DELETION_REQUEST = 'CLIENT_DELETION_REQUEST',
    CLIENT_DISABLE_REQUEST = 'CLIENT_DISABLE_REQUEST',
    CLIENT_ENABLE_REQUEST = 'CLIENT_ENABLE_REQUEST',
    CLIENT_RENAME_REQUEST = 'CLIENT_RENAME_REQUEST',
    AUTH_CERT_DELETION_REQUEST = 'AUTH_CERT_DELETION_REQUEST',
    ADDRESS_CHANGE_REQUEST = 'ADDRESS_CHANGE_REQUEST',
    MAINTENANCE_MODE_ENABLE_REQUEST = 'MAINTENANCE_MODE_ENABLE_REQUEST',
    MAINTENANCE_MODE_DISABLE_REQUEST = 'MAINTENANCE_MODE_DISABLE_REQUEST',
}
